import React, { useEffect, useState } from 'react'
import ProductDetails from './ProductDetails'
import decodeTokenAndGetUserId from '../../../utils/decodedToken';

export default function Products() {
    const [orders, setOrders] = useState([]);
    const [products, setProducts] = useState([]);
  
    useEffect(() => {
      const fetchOrders = async () => {
        const token = localStorage.getItem('token');
        const userId = decodeTokenAndGetUserId(token);
  
        try {
          const response = await fetch(`http://localhost:3000/api/products/userorder/${userId}`);
          const data = await response.json();
          setOrders(data);
  
          const productResponses = await Promise.all(
            data.map(async (order) =>
              Promise.all(
                order.product.map(async (product) => {
                  const productResponse = await fetch(`http://localhost:3000/api/products/get-product/${product.productId}`);
                  return productResponse.json();
                })
              )
            )
          );
          setProducts(productResponses);
        } catch (error) {
          console.error('Error fetching orders:', error);
        }
      };
  
      fetchOrders();
    }, []);
  
  return (
<div className="container mx-auto p-8 mt-16">
      <div className="mt-8">
        <div className="text-2xl font-bold mb-4">Your Orders</div>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded-lg">
            <thead className="bg-gray-800 text-white">
              <tr>
                <th className="py-2 px-4 md:table-cell sm:table-cell">Order</th>
                <th className="py-2 px-4 md:table-cell sm:table-cell">Product</th>
                <th className="py-2 px-4 md:table-cell sm:table-cell">Quantity</th>
                <th className="py-2 px-4 md:table-cell sm:table-cell">Order Date</th>
                <th className="py-2 px-4 md:table-cell sm:table-cell">Price</th>
              </tr>
            </thead>
            <tbody>
              {orders &&
                orders.map((order, orderIndex) =>
                  order.product.map((product, productIndex) => (
                    <tr key={product._id}>
                      <td className="py-2 px-4 md:table-cell sm:table-cell">{orderIndex + 1}</td>
                      <td className="py-2 px-4 md:table-cell sm:table-cell">
                        <ProductDetails product={products[orderIndex]?.[productIndex]} />
                      </td>
                      <td className="py-2 px-4 md:table-cell sm:table-cell">{product.quantity}</td>
                      <td className="py-2 px-4 md:table-cell sm:table-cell">{order.order_date}</td>
                      <td className="py-2 px-4 md:table-cell sm:table-cell">{order.price}</td>
                    </tr>
                  ))
                )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
      
      )
}
